import { Component, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralTask } from 'libs/flyfreely/src/lib/services/generalTasks.service';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subject, takeUntil } from 'rxjs';
import { GeneralTaskEditComponent } from '../general-task-edit/general-task-edit.component';

@Component({
    selector: 'general-task-details-dialogue',
    templateUrl: './general-task-details-dialogue.component.html',
    styleUrls: ['./general-task-details-dialogue.component.css']
})
export class GeneralTaskDetailsDialogueComponent {
    @Input() taskId: number;
    @ViewChild('editTaskDialogue', { static: false })
    editTaskDialogue: GeneralTaskEditComponent;
    task: GeneralTask;

    isEditing = false;

    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private modal: BsModalRef<GeneralTaskDetailsDialogueComponent>,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        modalOptions: ModalOptions
    ) {
        modalOptions.closeInterceptor = () => {
            if (this.isEditing) {
                this.editTaskDialogue.onCancel();
                return Promise.reject();
            }
            return Promise.resolve();
        };

        this.isEditing = this.router.routerState.snapshot.url.includes('/edit');
        this.router.events
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(() => {
                this.isEditing =
                    this.router.routerState.snapshot.url.includes('/edit');
            });
    }

    onCancel() {
        this.modal.hide();
    }

    toggleViewEdit() {
        if (!this.isEditing) {
            this.router.navigate(['..', `${this.taskId}`, 'edit'], {
                queryParamsHandling: 'merge',
                replaceUrl: true,
                relativeTo: this.activatedRoute
            });
        } else {
            this.router.navigate(['..', `${this.taskId}`], {
                queryParamsHandling: 'merge',
                replaceUrl: true,
                relativeTo: this.activatedRoute
            });
        }
    }

    onTaskDeleted() {
        this.modal.hide();
    }

    taskUpdated(task: GeneralTask) {
        this.toggleViewEdit();
    }
}
